// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aOtfvxKrj4ciLzhc3oZZ {
  overflow-x: scroll;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.aOtfvxKrj4ciLzhc3oZZ .field-body {
  flex: none;
  max-width: inherit;
}
.aOtfvxKrj4ciLzhc3oZZ .Yv2jZ6PnZ4tGe_foRkGZ {
  margin-bottom: 0;
}

.trWOnX4g_WYRXdBjYtiU {
  display: grid;
  gap: 10px;
  grid-template-columns: 50% 50%;
  height: calc(calc(100dvh - 3.25rem - 57px - 50px) - 1px);
}
.gq9F7sUZv3rkatQ9SWl1 {
  grid-template-columns: none;
}
.gq9F7sUZv3rkatQ9SWl1 .table-main {
  height: calc((calc(100dvh - 3.25rem - 57px - 50px)) * 0.4 - 10px / 2) !important;
}
.gq9F7sUZv3rkatQ9SWl1 .q49Dg22k1kPOwUssjEDH {
  height: calc((calc(100dvh - 3.25rem - 57px - 50px) - 1px) * 0.6 - 10px / 2) !important;
}
.gq9F7sUZv3rkatQ9SWl1 form {
  display: flex;
  flex-wrap: wrap;
}
.gq9F7sUZv3rkatQ9SWl1 form .field-pair {
  width: 50%;
}
.gq9F7sUZv3rkatQ9SWl1 form .field-pair:nth-child(5) {
  width: inherit;
  margin-right: 30px;
}
.gq9F7sUZv3rkatQ9SWl1 form .field-pair:nth-child(6) {
  width: inherit;
  margin-right: 30px;
}
.trWOnX4g_WYRXdBjYtiU .table-wrapper {
  height: calc(100dvh - 3.25rem - 57px - 50px);
  overflow-y: scroll;
}
.q49Dg22k1kPOwUssjEDH {
  height: calc(calc(100dvh - 3.25rem - 57px - 50px) - 1px);
  overflow-y: scroll;
}`, "",{"version":3,"sources":["webpack://./packages/dre-magi-translate/frontend/src/pages/admin/project/segment/script/list/ScriptList/ScriptList.module.scss"],"names":[],"mappings":"AAAA;EAEE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAAF;AAEE;EACE,UAAA;EACA,kBAAA;AAAJ;AAEE;EACE,gBAAA;AAAJ;;AAIA;EAGE,aAAA;EACA,SAAA;EACA,8BAAA;EAUA,wDAAA;AAZF;AAcE;EACE,2BAAA;AAZJ;AAcI;EACE,gFAAA;AAZN;AAcI;EACE,sFAAA;AAZN;AAgBI;EACE,aAAA;EACA,eAAA;AAdN;AAeM;EACE,UAAA;AAbR;AAeM;EACE,cAAA;EACA,kBAAA;AAbR;AAeM;EACE,cAAA;EACA,kBAAA;AAbR;AAkBE;EACE,4CAAA;EACA,kBAAA;AAhBJ;AAmBE;EACE,wDAAA;EACA,kBAAA;AAjBJ","sourceRoot":""}]);
// Exports
export var header = `aOtfvxKrj4ciLzhc3oZZ`;
export var selectorOption = `Yv2jZ6PnZ4tGe_foRkGZ`;
var _1 = `trWOnX4g_WYRXdBjYtiU`;
export { _1 as "script-list" };
var _2 = `gq9F7sUZv3rkatQ9SWl1`;
export { _2 as "script-list-horizontal" };
var _3 = `q49Dg22k1kPOwUssjEDH`;
export { _3 as "script-list-form" };
export default ___CSS_LOADER_EXPORT___;
